import ZoomImage from "./ZoomImage";
import {

    ChevronLeft,

    ChevronRight

} from "lucide-react";
import useSwipe from "./hooks/useSwipe";

export default function ModalBody({

    gallery,

}) {

    const swipe = useSwipe({

        onNext: gallery.next,

        onPrevious: gallery.previous,

    });

    console.log(gallery.selected);

    if (!gallery.selected)
        return null;

    return (

        <div className="gallery-modal-body"
            onTouchStart={swipe.onTouchStart}
            onTouchEnd={swipe.onTouchEnd}>
            <button
                className="thumb-nav left"
                onClick={gallery.previous}
             >
          <ChevronRight size={28} />
            </button>

            <ZoomImage
                image={gallery.selected}
                hoverZoom={false}
                wheelZoom={true}
                draggable={true}
                maxScale={5}

            />

            <button
                className="thumb-nav right"
                onClick={gallery.next}
            >
                <ChevronLeft size={28} />
            </button>



            <div className="gallery-counter">

                {gallery.currentIndex + 1}

                {" / "}

                {gallery.images.length}

            </div>

        </div>

    );

}